import React from 'react';
import styled from 'styled-components/macro';

interface Props {
    children: React.ReactNode;
    className?: string;
}

export const PcPageLayout = (props: Props) => {
    return (
        <S_PcPageLayout className={props.className}>
            <S_MainContent>{props.children}</S_MainContent>
        </S_PcPageLayout>
    );
};

const S_PcPageLayout = styled.div`
    display: flex;
    justify-content: space-between;
    width: 1260px;
    margin: 0 auto;
`;

const S_MainContent = styled.div`
    overscroll-behavior-y: none;
    min-height: 100vh;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
`;
